import { SYS_MSG as TYPES, USER_MSG_TYPES } from 'constants';
export const SYSTEM_MSG = {
  [TYPES.GROUP_CREATED]: msg => 'مرحبا! شارك الرمز ادناه حتى يستطيع المستخدمين الإنضمام الى مجموعتك.',
  [TYPES.GROUP_UPDATED]: msg => 'تم تحديث معلومات المجموعة',
  [TYPES.GROUP_CLOSED]: msg => 'تم اغلاق الانضمام للمجموعة من قبل الادمن',
  [TYPES.GROUP_OPENED]: msg => `تم اعادة فتح الانضمام للمجموعة! شارك الرمز ${msg.data.code} حتى يستطيع المستخدمين الإنضمام الى مجموعتك.`,
  [TYPES.USER_JOINED]: msg => `انضم ${msg.user.name} للمجموعة`,
  [TYPES.USER_REJOINED]: msg => `عاد ${msg.user.name} للمجموعة`,
  [TYPES.MAKE_ADMIN]: msg => `${msg.data.name} أصبح آدمن`,
  [TYPES.UNMAKE_ADMIN]: msg => `${msg.data.name}  لم يعد آدمن تم إبعاده`,
  [TYPES.USER_LEFT]: msg => 'غادر المجموعة',
  [TYPES.ADD_TASK]: msg => `تم اضافة "${msg.data.title}" الى قائمة المهام`,
  [TYPES.UPDATE_TASK]: msg => `تم تحديث "${msg.data.title}" في قائمة المهام`,
  [TYPES.REMOVE_TASK]: msg => `  تم حذف "${msg.data.title}" من قائمة المهام `,
  [TYPES.ADD_MATERIAL]: msg => (msg.data.length === 1 ? `تم اضافة "${msg.data[0].name}" الى قائمة المنهج` : `تم اضافة "${msg.data.length}" ملفات الى تبويب المنهج`),
  [TYPES.REMOVE_MATERIAL]: msg => `تمت ازالة "${msg.data.name}" من المنهج`,
  [TYPES.UPDATE_MATERIAL]: msg => `تم تحديث "${msg.data.name}" في قائمة المنهج`,
  [TYPES.MEMBER_BLOCKED]: msg => `تم حظر ${msg.data.name} من المجموعة`,
  [TYPES.MEMBER_UNBLOCKED]: msg => `تم فك حظر ${msg.data.name} من المجموعة`,
  [TYPES.MEMBER_REMOVED]: msg => `تمت ازالة ${msg.data.name} من المجموعة`,
  [TYPES.GROUP_AVATAR_CHANGED]: msg => `${msg.user.name} حدث صورة المجموعة`
};

export const SYSTEM_LAST_MSG = {
  [TYPES.GROUP_CREATED]: msg => `${msg.user.name}تم انشاء مجموعة`,
  [TYPES.GROUP_UPDATED]: () => 'تم تحديث معلومات المجموعة',
  [TYPES.GROUP_CLOSED]: () => `تم اغلاق الانضمام للمجموعة`,
  [TYPES.GROUP_OPENED]: () => `تم اعادة فتح الانضمام للمجموعة`,
  [TYPES.USER_JOINED]: msg => `انضم ${msg.user.name} الى المجموعة`,
  [TYPES.USER_REJOINED]: msg => `عاد ${msg.user.name} للمجموعة`,
  [TYPES.MAKE_ADMIN]: msg => `${msg.data.name} is now an admin`,
  [TYPES.UNMAKE_ADMIN]: msg => `${msg.data.name} is no longer an admin`,
  [TYPES.USER_LEFT]: msg => `غادر ${msg.user.name} المجموعة`,
  [TYPES.ADD_TASK]: msg => `${msg.user.name} اضاف مهمة جديدة`,
  [TYPES.UPDATE_TASK]: msg => `${msg.user.name} قام بتحرير مهمة`,
  [TYPES.REMOVE_TASK]: msg => `${msg.user.name} ازال مهمة`,
  [TYPES.ADD_MATERIAL]: msg => `${msg.user.name} أضاف منهج`,
  [TYPES.REMOVE_MATERIAL]: msg => `${msg.user.name} أزال منهج`,
  [TYPES.UPDATE_MATERIAL]: msg => `${msg.user.name}حدث المنهج `,
  [TYPES.MEMBER_BLOCKED]: msg => `تم حظر ${msg.data.name}`,
  [TYPES.MEMBER_UNBLOCKED]: msg => `تم فك حظر ${msg.data.name}`,
  [TYPES.MEMBER_REMOVED]: msg => `تمت ازالة ${msg.data.name}`,
  [TYPES.GROUP_AVATAR_CHANGED]: msg => `تم تحديث صورة المجموعة`
};

const UPLOAD = {
  VIDEO: 'يرفع مقطع فيديو',
  PHOTO: 'يرفع صورة'
};

export const USER_LAST_MSG = {
  [USER_MSG_TYPES.DELETED]: 'هذه الرسالة تم مسحها',
  [USER_MSG_TYPES.VIDEO]: 'مقطع فيديو',
  [USER_MSG_TYPES.PHOTO]: 'صورة',
  [USER_MSG_TYPES.UPLOAD]: msg => UPLOAD[msg.upload_type],
  [USER_MSG_TYPES.LOCATION]: 'موقع جغرافي',
  [USER_MSG_TYPES.CONTACT]: 'جهة تواصل'
};

export const DELETED_MSG = 'لقد مسحت هذه الرسالة';

export const NOTIFICAION_BASE_FOOTER = name => `بواسطة ${name} في`;



// WEBPACK FOOTER //
// ./src/lang/ar/messages.js